import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import Gdpr from './pages/Gdpr.tsx'
import Podmienky from './pages/Podmienky.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/gdpr" element={<Gdpr />} />
        <Route path="/podmienky" element={<Podmienky />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
